export const INVALID_TOKEN = [
  'invalid token',
  'Invite token not valid.'
]
